import { Image, ImageProps } from 'theme-ui'

const Camelot = (props: ImageProps) => {
  return <Image width={16} src="/svgs/camelot.svg" {...props} />
}
export default Camelot
